"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCancelAppointment = exports.useHasUpcomingAppointment = exports.useGetAppointmentQuestions = exports.useAvailableAppointmentDates = exports.useCreateAppointment = exports.useGetAvailableAppointmentCampaignsByDate = exports.useGetAppointmentCampaigns = exports.useGetAppointments = void 0;
var appointment_1 = require("../appointment");
var react_query_1 = require("react-query");
function useGetAppointments(patientId, options) {
    return (0, react_query_1.useQuery)(["get-appointments", patientId], function () { return (0, appointment_1.getAppointments)(patientId); }, options);
}
exports.useGetAppointments = useGetAppointments;
function useGetAppointmentCampaigns(pharmacyId, options) {
    return (0, react_query_1.useQuery)(["appointment-campaigns"], function () { return (0, appointment_1.getAppointmentCampaigns)(pharmacyId); }, options);
}
exports.useGetAppointmentCampaigns = useGetAppointmentCampaigns;
function useGetAvailableAppointmentCampaignsByDate(pharmacyId, startTime, options) {
    return (0, react_query_1.useQuery)(["appointment-campaigns-by-date"], function () { return (0, appointment_1.getAvailableAppointmentCampaignsByDate)(pharmacyId, startTime); }, options);
}
exports.useGetAvailableAppointmentCampaignsByDate = useGetAvailableAppointmentCampaignsByDate;
function useCreateAppointment(options) {
    var queryClient = (0, react_query_1.useQueryClient)();
    return (0, react_query_1.useMutation)(appointment_1.createAppointmentRequest, __assign(__assign({}, options), { onSuccess: function () { return queryClient.invalidateQueries(["get-appointments"]); } }));
}
exports.useCreateAppointment = useCreateAppointment;
function useAvailableAppointmentDates(pharmacyId, campaignOptionId, options) {
    return (0, react_query_1.useQuery)(["appointment-dates"], function () { return (0, appointment_1.getAppointmentDates)(pharmacyId, campaignOptionId); }, options);
}
exports.useAvailableAppointmentDates = useAvailableAppointmentDates;
function useGetAppointmentQuestions(request, options) {
    return (0, react_query_1.useQuery)(["appointment-questions"], function () { return (0, appointment_1.getAppointmentQuestions)(request); }, options);
}
exports.useGetAppointmentQuestions = useGetAppointmentQuestions;
function useHasUpcomingAppointment(patientId, options) {
    var _a;
    var allAppointments = useGetAppointments(patientId, options).data;
    var upcomingAppointments = (_a = allAppointments === null || allAppointments === void 0 ? void 0 : allAppointments.filter(function (appointment) { return new Date(appointment.scheduledDateTime) > new Date(); })) !== null && _a !== void 0 ? _a : [];
    return upcomingAppointments.length > 0;
}
exports.useHasUpcomingAppointment = useHasUpcomingAppointment;
function useCancelAppointment(params) {
    var queryClient = (0, react_query_1.useQueryClient)();
    return (0, react_query_1.useMutation)(appointment_1.cancelAppointmentRequest, __assign(__assign({}, params), { onSuccess: function () { return queryClient.invalidateQueries(["get-appointments"]); } }));
}
exports.useCancelAppointment = useCancelAppointment;
